import { Flex } from 'foundations-components/components/Flex';
import { Tag } from 'foundations-components/transitional/components/Tag';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useSearchParams } from 'marketplace-ui-common/hooks/useSearchParams';
import { useFilterTags } from '../hooks/useFilterTags';
import { ClearFiltersButton } from './ClearFiltersButton';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function FilterTags() {
  const params = useSearchParams();
  const filterTags = useFilterTags();
  if (filterTags.length === 0) return null;
  return /*#__PURE__*/_jsxs(Flex, {
    flexWrap: "wrap",
    gap: "200",
    children: [filterTags.map(tag => /*#__PURE__*/_jsx(Tooltip, {
      title: tag.tooltip,
      children: /*#__PURE__*/_jsxs(Tag, {
        marginInlineStart: "0 !important",
        closeable: true,
        onCloseClick: () => params.deleteFromList(tag.field, tag.value),
        use: "info",
        children: [tag.icon && /*#__PURE__*/_jsx(IconHolder, {
          compact: true,
          icon: tag.icon,
          marginInlineEnd: "100"
        }), tag.text]
      })
    }, `${tag.field}-${tag.text}`)), /*#__PURE__*/_jsx(ClearFiltersButton, {})]
  });
}